export default __webpack_public_path__ + "static/media/aptus-logo-icon-colour.a01217f9.png";